import React from "react";
import module_style from "../style.module.css";
import { MoreActions } from "ui/modules/MoreActions";
import EditIcon from "@material-ui/icons/Edit";
import Delete from "@material-ui/icons/Delete";
import Dots from "@material-ui/icons/DragIndicator";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { isInteger } from "utils/validations";

const AwardsList = ({
  data,
  set_data,
  set_show_modal,
  set_selected_id,
  handleDelete,
  disableAllEdits,
}) => {
  const options = [
    {
      title: "Edit",
      icon: <EditIcon />,
      handleClick: () => set_show_modal(true),
    },
    { title: "Delete", icon: <Delete />, handleClick: () => handleDelete() },
  ];

  const handleOnDragEnd = (result) => {
    if (
      !isInteger(result?.destination?.index) ||
      !isInteger(result?.source?.index)
    )
      return;
    let temp = data;
    const reorderedData = temp.splice(result.source.index, 1);
    temp.splice(result.destination.index, 0, ...reorderedData);
    for (let i = 0; i < temp.length; i++) {
      let item = temp[i];
      item.id = i;
    }

    set_data([...temp]);
  };

  return (
    <DragDropContext onDragEnd={handleOnDragEnd}>
      <Droppable droppableId="awards" type="AWARDS" mode="standard">
        {(provided) => {
          return (
            <div ref={provided.innerRef}>
              {data
                ?.filter((item) => !item.draft)
                .map((item, index) => (
                  <Draggable
                    key={`awards-${item?.id}`}
                    draggableId={`awards-${item?.id}`}
                    index={index}
                  >
                    {(provided) => (
                      <div>
                        <div
                          ref={provided.innerRef}
                          {...provided.draggableProps}
                        >
                          <>
                            <div className={`mt-2 mb-2 position-relative`}>
                              {provided && (
                                <div
                                  className={`mr-1 ${module_style.drag_svg}`}
                                  style={{ cursor: "grab" }}
                                  {...provided.dragHandleProps}
                                >
                                  <Dots />
                                </div>
                              )}
                              <div className={`${module_style.card}`}>
                                <div className={`${module_style.dots_svg}`}>
                                  {disableAllEdits ? null : (
                                    <div
                                      onClick={() => set_selected_id(item.id)}
                                    >
                                      <MoreActions
                                        options={options}
                                        shift={{ x: 45, y: 70 }}
                                      />
                                    </div>
                                  )}
                                </div>
                                <div
                                  className={`${module_style.card_title} line_max_1 ${module_style.clip_title}`}
                                >
                                  {item?.award_name}
                                </div>
                                <div
                                  className={`${module_style.card_description} mt-1`}
                                >
                                  {item?.organisation_name}
                                </div>
                                <div
                                  className={`${module_style.card_info} mt-1`}
                                >
                                  {item?.year}
                                </div>
                              </div>
                            </div>
                          </>
                        </div>
                        {provided.placeholder}
                      </div>
                    )}
                  </Draggable>
                ))}
              {provided.placeholder}
            </div>
          );
        }}
      </Droppable>
    </DragDropContext>
  );
};

export default AwardsList;
